import { Box } from "@chakra-ui/layout";
import { FC, forwardRef, Ref } from "react";

type Props = {
  isActive: boolean;
  ref: Ref<HTMLDivElement>;
}

export const TopLevelDropzone:FC<Props> = forwardRef(
  ({ isActive }, ref: Ref<HTMLDivElement>
) => (
  <Box
    ref={ref}
    height={isActive ? '74px' : '15px'}
    opacity={isActive ? 1 : 0}
    layerStyle={'with-top-level-dropzone'}
  />
));

TopLevelDropzone.displayName = 'TopLevelDropzone';
